import React, { FC, useContext, useEffect, useMemo, useRef, useState } from 'react';
// @ts-ignore
import kkmapgl from '@/assets/sdk/kkmap-gl.es';
// @ts-ignore
import '@/assets/sdk/kkmap-gl.css';
import styles from './index.module.scss';
import IconAreaPng from '../../../../imgs/area.png';
import twoD from '../../../../imgs/2D.png';
import threeD from '../../../../imgs/3D.png';
import IconAreaInactivePng from '../../../../imgs/icon-area-inactive.png';
import IconLightPng from '../../../../imgs/light@2x.png';
import IconLightInactivePng from '../../../../imgs/light-inactive@2x.png';
import switchOnPng from '../../../../imgs/switch-on.png';
import switchOffPng from '../../../../imgs/switch-off.png';
import { isNil } from 'lodash-es';
import { ShareDataPowerMapContext } from '../../index';
import { getAssetBaseUrl } from '@/utils/utils';
import { ShareDataWrapperContext } from '../../../../index';
import * as echarts from 'echarts';
import { getBarChartOption, getPieChartOption } from './chart';
import {
  changeDom,
  createChildrenStationDom,
  createDom,
  createLightPopupHtml,
  createPstationDom,
  createPulsingDot,
  getPopupHtml,
  getStationPopupHtml,
  loadImageAsync,
  mapExtensionModule,
} from './map';
import {
  apiV2ElectricMapConfigGetRoomMapListPost,
  apiV2ElectricMapDataAreaPost,
  apiV2ElectricMapDataAreaV2Post,
  apiV2ElectricMapDataElectricPowerPost,
  apiV2ElectricMapDataGgdDataPost,
  apiV2ElectricMapDataUnelectricLeftPost,
  apiV2ElectricMapDataUnelectricRightPost,
  apiV2GgdBatchOperateStatusPost,
  V2ElectricMapDataAreaPostResponse,
  V2ElectricMapDataAreaV2PostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { Modal } from '@maxtropy/components';
import { HighMastLightStatus, HighMastLightStatusDisplay } from '@/pages/WgqAllMaps/const';

interface MapViewProps {
  className?: string;
  children?: React.ReactNode;
}

const baseUrl = getAssetBaseUrl();

export type AreaItem = Exclude<V2ElectricMapDataAreaPostResponse['list'], undefined>[number];
export type StationItem = Exclude<V2ElectricMapDataAreaV2PostResponse['list'], undefined>[number];

const MapView: FC<MapViewProps> = props => {
  const { className, children } = props;
  const { isFullScreen, isStandardSize, loadMap, currentNav } = useContext(ShareDataWrapperContext);
  const { scaleData } = useContext(ShareDataPowerMapContext);
  const [mapLoaded, setMapLoaded] = useState<boolean>(false);
  // const [is2D, setIs2D] = useState<boolean>(false); // 2/3D切换
  const [stationIdList, setStationIdList] = useState<{ parentId?: number; childList?: number[] }>();
  const [stationInfoList, setStationInfoList] = useState<any[]>([]);
  const [originList, setOriginList] = useState<AreaItem[]>([]);
  const hasInitArea = useRef<boolean>(false);
  const hasInitGgd = useRef<boolean>(false);
  const selectedAreaId = useRef<string | null>(null);
  const popup = useRef<any>(null);
  const map = useRef<any>(null);

  const popupsRef = useRef<
    {
      popup: any;
      area: AreaItem;
    }[]
  >([]);
  const [markerVisible, setMarkerVisible] = useState({
    area: true,
    light: true,
  });

  useEffect(() => {
    apiV2ElectricMapDataAreaPost({}).then(res => {
      setOriginList(res.list ?? []);
    });
    apiV2ElectricMapConfigGetRoomMapListPost({}).then(res => {
      setStationIdList({
        parentId: res?.list?.[0]?.roomId,
        childList: (res?.list?.[0]?.childList ?? [])
          .filter(i => !isNil(i))
          .map(item => item?.roomId)
          .filter(c => !isNil(c)) as number[],
      });
    });
  }, []);

  useEffect(() => {
    if (!stationIdList || (stationIdList.childList?.length === 0 && !stationIdList.parentId)) return;

    const roomIdList = [stationIdList?.parentId, ...(stationIdList?.childList ?? [])].filter(i => !isNil(i));
    apiV2ElectricMapDataAreaV2Post({ roomIdList: roomIdList as number[] }).then(res => {
      setStationInfoList(res.list ?? []);
    });
  }, [stationIdList]);

  const markerList = useMemo(() => originList.filter(a => !a.ggdFlag), [originList]);
  // const stationList = useMemo(() => markerList.filter(a => !isNil(a.roomId)), [markerList]);
  const areaList = useMemo(() => markerList.filter(a => isNil(a.roomId) && !isNil(a.energyUnitId)), [markerList]);
  const lightList = useMemo(() => originList.filter(a => a.ggdFlag), [originList]);

  useEffect(() => {
    setMapLoaded(false);

    if (!window.kkmapgl) window.kkmapgl = kkmapgl;
    if (!window.mapgl) window.mapgl = kkmapgl;

    map.current = new kkmapgl.Map({
      container: 'map',
      minZoom: 15,
      maxZoom: 21,
      zoom: 15.8909,
      bearing: 57.5576,
      pitch: 65.8413,
      center: [121.62549860351851, 31.33799862542179],
      mapType: '3d-dark',
      style: {
        version: 8,
        sources: {},
        layers: [],
      },
      showPage: true,
      env3D: {
        defaultLights: false,
      },
      dracoPath: baseUrl + '/draco/',
      defaultModel: {
        type: 'glb',
        url: baseUrl + '/models/091501.glb',
        draco: true,
        ktx2Parse: true,
        useMeshOpt: true,
      },
    });
    map.current.showLoading(false);
    const mapExtension = mapExtensionModule();
    mapExtension.setMapInstance(map.current);
    map.current.on('load', function () {
      setMapLoaded(true);
    });
    map.current.on('click', function (e: any) {
      let objs = map.current.tb.queryRenderedFeatures(e.point, map.current.tb.scene, true);
      if (objs.length > 0) {
        const modelCode = objs[0].object.parent.name;
        console.log('dianji', modelCode);
        if (modelCode === 'qt-jianzhuwu020') {
          window.open(`/35kv-dashboard/`, '_blank');
        }
      }
    });
  }, []);

  useEffect(() => {
    if (!map.current) return;
    if (!mapLoaded || !areaList.length) return;
    if (hasInitArea.current) return;
    hasInitArea.current = true;
    setTimeout(() => {
      areaList.forEach(area => {
        createPopupMarker(area);
      });
    }, 100);
  }, [mapLoaded, areaList]);

  // 总站（配电站）
  useEffect(() => {
    if (!map.current) return;
    if (!mapLoaded || !stationInfoList.length) return;

    const pStation = stationInfoList.find(i => i.roomId === stationIdList?.parentId);

    const el = document.createElement('div');
    el.innerHTML = createPstationDom(pStation, scaleData);
    const markerPopup = new kkmapgl.Popup({
      closeButton: false,
      closeOnClick: false,
      offset: [0, 0],
      className: 'area-marker',
    })
      .setLngLat([pStation.pointLng, pStation.pointLat])
      .setDOMContent(el)
      .addTo(map.current);

    // 点击事件
    const target = el.querySelector(`#icon-cap-${pStation.roomId}`);
    // 添加tooltip
    const popupElem = markerPopup.getElement();
    const targetTip = popupElem.querySelector(`#tooltip-${pStation.roomId}`) as HTMLDivElement | null;
    target?.addEventListener('mouseenter', () => {
      if (targetTip) {
        targetTip!.style.display = 'block';
      }
    });
    target?.addEventListener('mouseleave', () => {
      if (targetTip) {
        targetTip!.style.display = 'none';
      }
    });

    // 配电站渲染
    const childStations = stationInfoList.filter(i => i.roomId !== stationIdList?.parentId);
    if (childStations && childStations.length > 0) {
      childStations?.forEach(item => createChildrenStationPopupMarker(item));
    }
  }, [mapLoaded, stationInfoList]);

  const createChildrenStationPopupMarker = (item?: StationItem) => {
    const el = document.createElement('div');
    el.innerHTML = createChildrenStationDom(item);
    new kkmapgl.Popup({
      closeButton: false,
      closeOnClick: false,
      offset: [0, 0],
      className: 'area-marker',
    })
      .setLngLat([item?.pointLng, item?.pointLat])
      .setDOMContent(el)
      .addTo(map.current);
  };

  useEffect(() => {
    if (!map.current) return;
    if (!mapLoaded || !lightList.length) return;

    if (hasInitGgd.current) return;
    hasInitGgd.current = true;

    const images: [string, string][] = [
      ['icon-light-on', `${baseUrl}/light-location-on@2x.png`],
      ['icon-line-on', `${baseUrl}/line-on@2x.png`],
      ['icon-line-off', `${baseUrl}/line-off@2x.png`],
      ['icon-line-offline', `${baseUrl}/line-offline@2x.png`],
      ['icon-bottom-on', `${baseUrl}/bottom-on@2x.png`],
      ['icon-bottom-off', `${baseUrl}/bottom-off@2x.png`],
      ['icon-light-off', `${baseUrl}/light-location-off@2x.png`],
      ['icon-light-offline', `${baseUrl}/light-location-offline@2x.png`],
    ];

    const init = async () => {
      try {
        await Promise.all(images.map(([name, url]) => loadImageAsync(map.current, name, url)));

        if (!map.current.hasImage('pulsing-dot')) {
          const pulsingDot = createPulsingDot(220, '87,251,139');
          map.current.addImage('pulsing-dot', pulsingDot, { pixelRatio: 2 });
        }
        setTimeout(() => {
          let source = map.current?.getSource('geojson');
          if (!source) {
            map.current.addSource('geojson', {
              type: 'geojson',
              data: {
                type: 'FeatureCollection',
                features: lightList.map((k, index) => ({
                  id: index,
                  type: 'Feature',
                  geometry: {
                    type: 'Point',
                    coordinates: [Number(k.pointLng), Number(k.pointLat)],
                  },
                  properties: {
                    ...k,
                    ggdStatusLabel: !isNil(k.intStatus)
                      ? HighMastLightStatusDisplay[k.intStatus as HighMastLightStatus]
                      : 'offline',
                  },
                })),
              },
            });
            source = map.current?.getSource('geojson');
          }
          addLightLayer();
        }, 7000);
      } catch (err) {
        console.error('图片加载失败:', err);
      }
    };

    init();
  }, [mapLoaded, lightList]);

  const clickLightIcon = (e: any) => {
    if (!e.features?.length) return;
    const feature = e.features[0];

    // 获取经纬度
    const [lng, lat] = feature.geometry.coordinates as [number, number];

    // 如果之前已有光圈，先移除
    if (map.current.getLayer('light-pulse')) {
      map.current.removeLayer('light-pulse');
    }
    if (map.current.getSource('light-pulse')) {
      map.current.removeSource('light-pulse');
    }

    // 添加一个临时 source
    map.current.addSource('light-pulse', {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: { type: 'Point', coordinates: [lng, lat] },
          },
        ],
      },
    });

    map.current.addLayer({
      id: 'light-pulse',
      type: 'symbol',
      source: 'light-pulse',
      layout: {
        'icon-image': 'pulsing-dot',
        'icon-size': 1,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'icon-offset': [0, -110],
      },
    });

    map.current.moveLayer('light-pulse', 'light');
    if (feature.properties) {
      apiV2ElectricMapDataGgdDataPost({ id: feature.properties.id }).then(res => {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = createLightPopupHtml(res);
        if (popup.current) {
          popup.current.remove();
          popup.current = null;
        }

        popup.current = new kkmapgl.Popup({
          closeButton: false,
          closeOnClick: false,
          offset: [20, -200],
          className: 'light-popup',
        })
          .setLngLat([lng, lat])
          .setDOMContent(wrapper)
          .addTo(map.current);
        setTimeout(() => {
          const closeBtn = wrapper.querySelector<HTMLDivElement>('#closePopupBtn');
          if (closeBtn) {
            closeBtn.addEventListener('click', () => {
              popup.current?.remove();
              popup.current = null;
              if (map.current.getLayer('light-pulse')) map.current.removeLayer('light-pulse');
              if (map.current.getSource('light-pulse')) map.current.removeSource('light-pulse');
            });
          }
          const moreLink = wrapper.querySelector<HTMLDivElement>('#moreLink');
          if (moreLink) {
            moreLink.addEventListener('click', () => {
              if (isNil(feature.properties?.deviceId)) {
                window.open(`/power/lighting/control`, '_blank');
              } else {
                window.open(`/power/lighting/control?deviceId=${feature.properties?.deviceId}`, '_blank');
              }
            });
          }
          const statusSwitch = wrapper.querySelector<HTMLDivElement>('#status-switch');
          if (statusSwitch) {
            statusSwitch.addEventListener('click', () => {
              Modal.confirm({
                title: (
                  <span style={{ color: 'var(--mx-text-base-color)' }}>
                    确定要下发<span style={{ color: '#E64242' }}>{res.intStatus === 1 ? '远程关闭' : '远程开启'}</span>
                    指令到{res.name}设备吗？
                  </span>
                ),
                okText: '确定',
                onOk() {
                  const newStatus = res.intStatus === 1 ? 0 : 1;

                  apiV2GgdBatchOperateStatusPost({
                    deviceIds: [feature.properties.deviceId],
                    status: newStatus,
                  })
                    .then(() => {
                      const source: any = map.current.getSource('geojson');
                      if (source) {
                        const data = (typeof source.getData === 'function'
                          ? source.getData()
                          : source._data ?? null) ?? {
                          type: 'FeatureCollection',
                          features: [],
                        };

                        const updated = {
                          ...data,
                          features: (data.features || []).map((f: any) => {
                            if (f.properties && f.properties.deviceId === feature.properties.deviceId) {
                              return {
                                ...f,
                                properties: {
                                  ...f.properties,
                                  ggdStatusLabel: newStatus === 1 ? 'on' : 'off',
                                  intStatus: newStatus,
                                },
                              };
                            }
                            return f;
                          }),
                        };

                        try {
                          source.setData(updated);
                        } catch (err) {
                          console.warn('source.setData failed:', err);
                        }
                      }

                      const statusImg = wrapper.querySelector<HTMLImageElement>('#status-switch');
                      if (statusImg) {
                        statusImg.src = newStatus ? switchOnPng : switchOffPng;
                      }
                    })
                    .catch(err => {
                      console.error('下发状态失败', err);
                    });
                },
              });
            });
          }
        }, 300);
      });
    }
  };

  const createPopupMarker = (area: AreaItem) => {
    const prev = popupsRef.current.find(k => k.area.id === area.id);
    if (prev) {
      return;
    }

    const el = document.createElement('div');
    el.innerHTML = createDom(area, false);

    const markerPopup = new kkmapgl.Popup({
      closeButton: false,
      closeOnClick: false,
      offset: [0, -10],
      className: 'area-marker',
    })
      .setLngLat([area.pointLng, area.pointLat])
      .setDOMContent(el)
      .addTo(map.current);

    // 点击事件
    el.addEventListener('click', () => {
      // 修改背景
      const popupElem = markerPopup.getElement();
      const target = popupElem.querySelector(`#marker-outer-${area.id}`) as HTMLDivElement | null;
      changeDom(area, target, true);

      if (!isNil(area.roomId)) {
        clickAlarmIcon(area);
        return;
      }

      if (!isNil(area.energyUnitId)) {
        clickAreaBox(area);
        return;
      }
    });

    popupsRef.current.push({
      popup: markerPopup,
      area,
    });
  };

  const safeAddLayer = (layerConfig: any) => {
    if (map.current.isStyleLoaded()) {
      map.current.addLayer(layerConfig);
    } else {
      map.current.once('styledata', () => safeAddLayer(layerConfig));
    }
  };

  const handleToggleMarker = (type: 'area') => {
    const newVisible = !markerVisible[type];

    if (popup) {
      popup.current?.remove();
      if (selectedAreaId.current) {
        const item = popupsRef.current.find(a => String(a.area.id!) === String(selectedAreaId.current));
        resetMarkerPopup(item?.area);
        selectedAreaId.current = null;
      }
    }
    // 显示
    if (newVisible) {
      areaList.forEach(area => {
        createPopupMarker(area);
      });
    } else {
      // 隐藏
      const newPopupRef: any[] = [];
      popupsRef.current.forEach(k => {
        if (isNil(k.area.roomId)) {
          k.popup.remove();
        } else {
          newPopupRef.push(k);
        }
      });
      popupsRef.current = newPopupRef;
    }

    setMarkerVisible(prev => ({ ...prev, [type]: !prev[type] }));
  };

  const clickAreaBox = async (area: AreaItem) => {
    const { id: areaId, name } = area;
    // 点击其他盒子，其他popUp去除
    if (popup.current) {
      const markerPopup = popupsRef.current.filter(k => k.area.id !== area.id);
      if (markerPopup.length > 0) {
        markerPopup.forEach(itemPopup => {
          const popupElem = itemPopup?.popup?.getElement();
          if (popupElem && itemPopup?.area) {
            const target = popupElem.querySelector(`#marker-outer-${itemPopup?.area?.id}`) as HTMLDivElement | null;
            changeDom(itemPopup?.area, target, false);
          }
        });
      }
      popup.current.remove();
      popup.current = null;
    }
    const [resLeft, resRight] = await Promise.all([
      apiV2ElectricMapDataUnelectricLeftPost({ id: areaId }),
      apiV2ElectricMapDataUnelectricRightPost({ id: areaId }),
    ]);
    popup.current = new kkmapgl.Popup({ closeOnClick: true, offset: 90, className: 'area-popup' })
      .setLngLat([area.pointLng, area.pointLat])
      .setHTML(getPopupHtml(resLeft, resRight, name ?? '--'))
      .addTo(map.current);

    setTimeout(() => {
      const closeBtn = document.getElementById('closePopupBtn');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => resetMarkerPopup(area));
      }

      const viewMoreBtn = document.getElementById('viewMoreBtn');
      if (viewMoreBtn) {
        viewMoreBtn.addEventListener('click', () => {
          window.open(`${window.ENERGY}/layout/home`, '_blank');
        });
      }

      // 左侧 折线 + 柱状图
      const lineDom = document.getElementById('popupLineChart');
      if (lineDom) {
        const lineChart = echarts.init(lineDom);
        lineChart.setOption(getBarChartOption(resLeft.electricityList ?? [], resLeft.units ?? []));
      }

      // 右侧 饼状图
      const pieDom = document.getElementById('popupPieChart');
      if (pieDom) {
        const pieChart = echarts.init(pieDom);
        pieChart.setOption(getPieChartOption(resRight.list));
      }
    }, 300);
  };

  const clickAlarmIcon = async (area: AreaItem) => {
    const { id: areaId, name, flag } = area;
    const { list } = await apiV2ElectricMapDataElectricPowerPost({ id: areaId });

    popup.current = new kkmapgl.Popup({ closeOnClick: false, offset: 90, className: 'alarm-popup' })
      .setLngLat([area.pointLng, area.pointLat])
      .setHTML(getStationPopupHtml(list ?? [], name ?? '--', flag ?? false))
      .addTo(map.current);

    setTimeout(() => {
      const closeBtn = document.getElementById('closePopupBtn');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => resetMarkerPopup(area));
      }
      const viewMoreBtn = document.getElementById('viewMoreBtn');
      if (viewMoreBtn) {
        viewMoreBtn.addEventListener('click', () => {
          window.open(`/power/station/configuration?stationId=${areaId}`, '_blank');
        });
      }
    }, 300);
  };

  const resetMarkerPopup = (area?: AreaItem) => {
    popup.current?.remove();
    if (!area) return;
    const markerPopup = popupsRef.current.find(k => k.area.id === area.id);
    const popupElem = markerPopup?.popup?.getElement();
    if (popupElem) {
      const target = popupElem.querySelector(`#marker-outer-${area.id}`) as HTMLDivElement | null;
      changeDom(area, target, false);
    }

    selectedAreaId.current = null;
  };

  const addLight = () => {
    if (markerVisible.light) {
      if (map.current.getLayer('light')) {
        map.current.removeLayer('light');
      }
      if (map.current.getLayer('light-line')) {
        map.current.removeLayer('light-line');
      }
      if (map.current.getLayer('bottom')) {
        map.current.removeLayer('bottom');
      }
    } else {
      addLightLayer();
    }
    setMarkerVisible(prev => ({ ...prev, light: !prev.light }));
  };

  const addLightLayer = () => {
    if (!map.current.getLayer('light')) {
      map.current?.addLayer({
        id: 'light',
        type: 'symbol',
        source: 'geojson',
        layout: {
          'icon-allow-overlap': true,
          'icon-ignore-placement': true,
          'icon-image': [
            'match',
            ['get', 'ggdStatusLabel'],
            'on',
            'icon-light-on',
            'off',
            'icon-light-off',
            'offline',
            'icon-light-offline',
            'icon-light-off',
          ],
          'icon-rotation-alignment': 'viewport',
          'icon-pitch-alignment': 'viewport',
          'icon-size': 0.5,
          'icon-offset': [0, -96 / 0.5 - 20],
        },
      });
      map.current.on('click', 'light', clickLightIcon);
    }
    if (!map.current.getLayer('light-line')) {
      map.current?.addLayer({
        id: 'light-line',
        type: 'symbol',
        source: 'geojson',
        layout: {
          'icon-allow-overlap': true,
          'icon-ignore-placement': true,
          'icon-image': [
            'match',
            ['get', 'ggdStatusLabel'],
            'on',
            'icon-line-on',
            'off',
            'icon-line-off',
            'offline',
            'icon-line-offline',
            'icon-line-off',
          ],
          'icon-rotation-alignment': 'viewport',
          'icon-pitch-alignment': 'viewport',
          'icon-size': 0.5,
          'icon-anchor': 'bottom',
        },
      });
    }
    if (!map.current.getLayer('bottom')) {
      // 底座
      map.current?.addLayer({
        id: 'bottom',
        type: 'symbol',
        source: 'geojson',
        layout: {
          'icon-allow-overlap': true,
          'icon-ignore-placement': true,
          'icon-image': [
            'match',
            ['get', 'ggdStatusLabel'],
            'on',
            'icon-bottom-on',
            'off',
            'icon-bottom-off',
            'offline',
            'icon-bottom-off',
            'icon-bottom-off',
          ],
          'icon-rotation-alignment': 'viewport',
          'icon-pitch-alignment': 'viewport',
          'icon-size': 0.5,
        },
      });
    }
  };

  // const change23D = () => {
  //   if (map.getMapType() === '3d-dark') {
  //     map.setMapType('2d');
  //   } else {
  //     map.setMapType('3d-dark');
  //   }
  //   setIs2D(!is2D);
  // };

  return (
    <div className={`${styles.map} ${className || ''}`} id="map">
      <div className={styles.legendList} style={{ left: isStandardSize ? '20px' : '936px' }}>
        <div
          className={`${markerVisible.area ? styles.activeAreaItem : styles.inActiveItem}`}
          onClick={() => handleToggleMarker('area')}
        >
          <img src={markerVisible.area ? IconAreaPng : IconAreaInactivePng} alt="" />
          <div>区域({areaList.length})</div>
        </div>

        <div className={`${markerVisible.light ? styles.activeLightItem : styles.inActiveItem}`} onClick={addLight}>
          <img src={markerVisible.light ? IconLightPng : IconLightInactivePng} alt="" />
          <div>高杆灯({lightList.length})</div>
        </div>
      </div>
      {/* <div
        className={styles.twoThree_img}
        onClick={() => change23D()}
        style={{ right: isStandardSize ? '20px' : '936px' }}
      >
        <img src={is2D ? threeD : twoD} alt="切换2/3D" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </div> */}
      {children}
    </div>
  );
};

export default MapView;
